import { useQuery } from 'react-query';
import { getDiet } from '../api/getDiet';

const useDiet = (dietName, dietQuality, userId) => {
  const result = useQuery(`diet_${dietName}_${dietQuality}_${userId}`, () => getDiet(dietName, dietQuality, userId), {
    refetchOnWindowFocus: false,
    staleTime: 60 * 60 * 1000,
    cacheTime: 60 * 60 * 1000,
  });
  return result;
};

export default useDiet;
